import React from "react";

// Material UI Components
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles((theme) => ({
  defaultLabel: {
    "&.MuiTypography-root": {
      color: theme.palette.MDCColors.textColor,
      fontFamily: theme.palette.typography.fontFamily,
    },
  },
  disabledLabel: {
    "&.MuiTypography-root": {
      color: theme.palette.MDCColors.color18,
      fontFamily: theme.palette.typography.fontFamily,
      fontWeight: theme.palette.typography.fontWeightMedium,
    },
  },
  optionalText: {
    color: theme.palette.MDCColors.color18,
    fontFamily: theme.palette.typography.fontFamily,
    fontWeight: theme.palette.typography.fontWeightMedium,
  },
}));

const MDCLabel = (props) => {
  const { label, variant, isOptional, isReadOnly, className } = props;

  const { defaultLabel, disabledLabel, optionalText } = useStyles();

  let MDCStyles = defaultLabel;
  if (isReadOnly) {
    MDCStyles = `${MDCStyles} ${disabledLabel}`;
  }

  let defaultVariant = "string";
  const appliedClassName = className ? className : MDCStyles;

  return (
    <>
      <Typography
        component={"span"}
        variant={variant ? variant : defaultVariant}
        className={appliedClassName}
      >
        {label}
        {isOptional ? (
          <span className={optionalText}>{" ".concat("(optional)")}</span>
        ) : (
          ""
        )}
      </Typography>
    </>
  );
};

export default MDCLabel;
